import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SelectedFirstPipe } from './pipes/selected-first.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { EventDatePickerComponent } from '../modules/projects/event-management/event-date-picker/event-date-picker.component';

@NgModule({
  declarations: [ShortNumberPipe, InitialsPipe, StripHtmlPipe, EventDatePickerComponent],
  exports: [ShortNumberPipe, InitialsPipe, StripHtmlPipe, EventDatePickerComponent, SafeHtmlPipe, SelectedFirstPipe],
  imports: [
    CommonModule,
    FormsModule,
    SelectedFirstPipe,
    SafeHtmlPipe
  ]
})
export class SharedModule { }
